"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeRequestBanners = void 0;
require("rxjs/add/operator/map");
var actions_1 = require("./actions");
var constants_1 = require("./constants");
var makeRequestBanners = function (getBannersByIds) { return function (action$) {
    return action$.ofType(constants_1.GET_BANNERS_DATA_SUCCESS).map(function (action) {
        var _a = action.payload, data = _a.data, zoneId = _a.zoneId;
        return actions_1.setBanners(data, zoneId, getBannersByIds);
    });
}; };
exports.makeRequestBanners = makeRequestBanners;
//# sourceMappingURL=epics.js.map